import * as z from "zod"

export const CredentialModel = z.object({
  id: z.number().int(),
  created_at: z.date(),
  updated_at: z.date(),
  key: z.string(),
  value: z.string(),
  /**
   * [TenantId]
   */
  tenant_id: z.string().nullish(),
  account_id: z.number().int().nullish(),
})
